// extracted by mini-css-extract-plugin
export default {"container":"styles_container__c7+66","title":"styles_title__vYFes","wrapper":"styles_wrapper__RzHQl"};